import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Micaela',
  age: 22,
  city: 'CABA',
  text: 'Siempre sentí que me faltaba algo para destacar en las clases. Desde que uso Dancers Pro, mi control corporal cambió por completo. ¡Increíble!',
  image: 'https://images.unsplash.com/photo-1518806118471-f28b20a1d79d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Tomás',
  age: 25,
  city: 'Córdoba',
  text: 'Estaba estancado repitiendo las mismas coreos. Este sistema me dio la estructura que necesitaba para entrenar de verdad. Muy recomendado.',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Sofía',
  age: 20,
  city: 'Rosario',
  text: 'Pensé que no tenía talento, pero era falta de método. En un mes mejoré más que en todo el año pasado. Gracias totales.',
  image: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Valentina',
  age: 24,
  city: 'Mendoza',
  text: 'La guía de movilidad y las rutinas son un 10. Entro a entrenar y ya sé exactamente qué hacer. Me siento mucho más segura.',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Lucas',
  age: 27,
  city: 'La Plata',
  text: 'Si querés dejar de perder el tiempo y mejorar en serio, esto es lo que necesitás. La mejor inversión para mi danza.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}];
export function Testimonials() {
  return <section className="py-14 bg-gray-50" data-id="element-158">
      <div className="max-w-5xl mx-auto px-4" data-id="element-159">
        <h2 className="text-2xl md:text-4xl font-black text-center text-black mb-12" data-id="element-160">
          Dancers que ya están{' '}
          <span className="text-sky-500" data-id="element-161">evolucionando</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-162">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl border border-gray-200 flex flex-col h-full shadow-sm" data-id="element-163">
              <div className="flex text-sky-500 mb-4" data-id="element-164">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-165" />)}
              </div>
              <p className="text-gray-600 mb-6 flex-grow text-base leading-relaxed" data-id="element-166">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-5 border-t border-gray-100" data-id="element-167">
                <img src={t.image} alt={t.name} className="w-11 h-11 rounded-full object-cover border-2 border-sky-200" data-id="element-168" />
                <div data-id="element-169">
                  <p className="font-bold text-black text-base" data-id="element-170">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-xs text-sky-600 font-medium" data-id="element-171">{t.city}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}